export default __webpack_public_path__ + "static/squiggle-d9b7e24beb1dc4cff397eb6ca43a0362.svg";